import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=285b9ca8&"
import script from "./BaseSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285b9ca8')) {
      api.createRecord('285b9ca8', component.options)
    } else {
      api.reload('285b9ca8', component.options)
    }
    module.hot.accept("./BaseSwitch.vue?vue&type=template&id=285b9ca8&", function () {
      api.rerender('285b9ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/BaseSwitch.vue"
export default component.exports